import React, { useMemo } from 'react';
import { useDecision } from '@optimizely/react-sdk';
import { useTrackOptimizely } from '@fff-web/fff-analytics';
import {
  UpgradeMembershipContext,
  GrowthUpgradeType,
} from './UpgradeMembershipContext';
import { GROWTH_UPGRADE_MEMBERSHIP } from '../../../utils/Optimizely/featureFlagVariations';

export const UpgradeMembershipProvider = ({
  children,
}: {
  children: React.ReactNode | React.ReactNodeArray;
}) => {
  const [growthUpgradeDecision] = useDecision(
    GROWTH_UPGRADE_MEMBERSHIP.FEATURE_FLAG
  );

  useTrackOptimizely(
    growthUpgradeDecision,
    GROWTH_UPGRADE_MEMBERSHIP.EXPERIMENT_NAME
  );

  const memoizedValues = useMemo(
    () => ({
      growthUpgrade: growthUpgradeDecision as GrowthUpgradeType,
    }),
    [growthUpgradeDecision]
  );

  return (
    <UpgradeMembershipContext.Provider
      value={{
        ...memoizedValues,
      }}
    >
      {children}
    </UpgradeMembershipContext.Provider>
  );
};
